import { render, staticRenderFns } from "./organization-dropdown.vue?vue&type=template&id=55e82334&"
import script from "./organization-dropdown.vue?vue&type=script&lang=js&"
export * from "./organization-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./organization-dropdown.vue?vue&type=style&index=0&id=55e82334&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports